"use client";
import React, { useState } from "react";
import Cta from "../Cta";
import { isFilled } from "@prismicio/client";

export default function CtaWrapper({ cta, padding, width }) {
  const ctaVariants = cta.map((item) => item.variant);
  const [isToggled, setIsToggled] = useState(false);
  return (
    <div className="flex flex-wrap gap-5">
      {cta.map((link, idx) =>
        isFilled.link(link) ? (
          <Cta
            key={idx}
            page={link}
            variant={isToggled ? ctaVariants.find((el) => el !== link.variant) : link.variant}
            toggleVariant={(isToggled) => {
              setIsToggled(isToggled);
            }}
            isToggled={isToggled}
            width={width}
            padding={padding}
          />
        ) : null
      )}
    </div>

  );
}
